import Home from "components/Home/Home";
import Dashboard from "components/Dashboard/Dashboard";
import NotFound from "components/NotFound/NotFound";
import Documents from "components/Documents/Documents";
import LearningCenter from "components/LearningCenter/LearningCenter";
import ChangeAllocations from "components/ChangeAllocations/ChangeAllocations";
import TakeAnnuityOutOfPlan from "components/TakeAnnuityOutOfPlan/TakeAnnuityOutOfPlan";
import StartIncome from "components/StartIncome/StartIncome";
import SetupAccount from "components/SetupAccount/SetupAccount";
import Notifications from "components/Notifications/Notifications";
import AddUpdateBeneficiary from "components/Beneficiary/AddUpdateBeneficiary";
import TestPage from "components/Test/TestPage";
import Auth from "components/Auth/Auth";
import Logout from "components/Logout/Logout";
import JointLifeInfo from "components/JointLifeInfo/JointLifeInfo";
import SuspendMonthlyPayout from "components/SuspendMonthlyPayout/SuspendMonthlyPayout";
import IncomeElection from "components/IncomeElection/IncomeElection";
import MonthlyPayoutElection from "components/MonthlyPayout/MonthlyPayoutElection";
import GlossaryTerms from "components/Glossary/GlossaryTerms";

export default Object.freeze({
  home: {
    component: <Home />,
    path: "/",
    isPrivate: false,
  },
  dashboard: {
    component: <Dashboard />,
    path: "/dashboard",
    isPrivate: true,
    layout: "MultiPageLayout",
  },
  documents: {
    component: <Documents />,
    path: "/documents",
    isPrivate: true,
    layout: "MultiPageLayout",
  },
  learningCenter: {
    component: <LearningCenter />,
    path: "/learning-center",
    isPrivate: true,
    layout: "MultiPageLayout",
  },
  changeAllocations: {
    component: <ChangeAllocations />,
    path: "/change-allocations/:id",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  takeAnnuityOutOfPlan: {
    component: <TakeAnnuityOutOfPlan />,
    path: "/take-annuity-out-of-plan/:id",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  startIncomeHome: {
    component: <StartIncome />,
    path: "/start-income",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  startIncomeHomeChild: {
    component: <StartIncome />,
    path: "/start-income/:id",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  setupAccount: {
    component: <SetupAccount />,
    path: "/setup-account",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  notifications: {
    component: <Notifications />,
    path: "/notifications",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  addUpdateBeneficiary: {
    component: <AddUpdateBeneficiary />,
    path: "/add-update-beneficiary",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  notFound: {
    component: <NotFound />,
    path: "*",
    isPrivate: false,
  },
  testPage: {
    component: <TestPage />,
    path: "/test-page",
    isPrivate: false,
  },
  learningCenterPublic: {
    component: <LearningCenter />,
    path: "/learning-page",
    isPrivate: false,
    layout: "MultiPageLayout",
  },
  auth: {
    component: <Auth />,
    path: "/auth",
    isPrivate: false,
  },
  logout: {
    component: <Logout />,
    path: "/logout",
    isPrivate: false,
  },
  jointLifeInfo: {
    component: <JointLifeInfo />,
    path: "/joint-life-information",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  suspendMonthlyPayout: {
    component: <SuspendMonthlyPayout />,
    path: "/suspend-monthly-payout",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  incomeElection: {
    component: <IncomeElection />,
    path: "/income-election/:id",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  monthlyPayout: {
    component: <MonthlyPayoutElection />,
    path: "/monthly-payout-election/:id",
    isPrivate: true,
    layout: "SinglePageLayout",
  },
  glossaryTerms: {
    component: <GlossaryTerms />,
    path: "/glossary-terms",
    isPrivate: true,
    layout: "MultiPageLayout",
  },
  videoLibrary: {
    component: <LearningCenter />,
    path: "/video-library",
    isPrivate: true,
    layout: "MultiPageLayout",
  },
});
